import { User } from './user.interface';
import { notifyError } from '@/core/helpers/notification.helper';
import { client } from '@/server';

export class UserService {
   async getUsers(userId: string) {
      const query = `
      SELECT * FROM users WHERE firebase_id != ? AND partner_id IS NULL 
      `;
      try {
         const response = await client.execute(query, [userId]);
         return response.rows;
      } catch (error) {
         console.error('Error fetching users:', error);
         notifyError({ title: 'Something went wrong while fetching the users' });
      }
   }

   async getUser(userId: string) {
      const query = `
      SELECT 
         u.*,
         CASE
            WHEN u.partner_id IS NULL THEN NULL
            ELSE json_object(
               'id', p.id,
               'name', p.name,
               'email', p.email,
               'cover_url', p.cover_url
            )
         END AS partner
      FROM users u
      LEFT JOIN 
         users p ON u.partner_id = p.id
      WHERE 
         u.firebase_id = ?
      `;

      try {
         const response = await client.execute(query, [userId]);
         const user = response.rows[0] as Record<string, any>;
         if (!user) return null;

         return {
            ...user,
            partner: user.partner ? JSON.parse(user.partner) : null,
         } as User;
      } catch (error) {
         console.error('Error fetching user:', error);
         notifyError({ title: 'Something went wrong while fetching the user' });
      }
   }

   async searchUser(emailOrName: string) {
      const query = `
         SELECT * FROM users 
         WHERE email LIKE ? OR name LIKE ?
      `;
      try {
         // Add wildcards (%) to the input for partial matching
         const searchTerm = `%${emailOrName}%`;
         const response = await client.execute(query, [searchTerm, searchTerm]);
         return response.rows;
      } catch (error) {
         console.error('Error fetching user by email or name:', error);
         notifyError({ title: 'Something went wrong while fetching the user' });
         return null;
      }
   }

   async postUser(user: User) {
      const query = `
         INSERT INTO users (email, name, cover_url, firebase_id) 
         VALUES (?, ?, ?, ?)
      `;
      try {
         const response = await client.execute(query, [user.email, user.name, user.cover_url, user.firebase_id]);
         return response.rows;
      } catch (error) {
         console.error('Error creating user:', error);
         notifyError({ title: 'Something went wrong while creating the user' });
      }
   }

   async putUser(user: User) {
      const query = `
         UPDATE users
         SET name = ?, cover_url = ?, email = ?
         ${user.partner_id ? ', partner_id = ?' : ''}
         WHERE firebase_id = ?
      `;
      try {
         const response = await client.execute(query, [user.name, user.cover_url, user.email, user.partner_id, user.firebase_id]);
         return response.rows[0];
      } catch (error) {
         console.error('Error updating user:', error);
         notifyError({ title: 'Something went wrong while updating the user' });
      }
   }

   async deleteUser() {
      throw Error('Method not implemented');
   }
}
